import { createAction, props } from '@ngrx/store';
import type { ContactListFilters, ContactRecord, ListFullContact } from '../../../../../core/interfaces/contact.interface';

// lists
export const FetchContactListRecords = createAction('[Lists-Contact] Fetch lists',
    props<{ listId: string, page: number, pagination: number, filter: ContactListFilters }>());

export const FetchContactListSuccess = createAction('[Lists-Contact] Fetch lists success',
    props<{ totalRecords: number, page: number, listName: string, records: ContactRecord[] }>(),
);

export const FetchContactListError = createAction('[Lists-Contact] Fetch list error ', props<{ error: any }>());

// contact
export const FetchContact = createAction('[Lists-Contact] Fetch contact', props<{ contactId: string }>());
export const FetchContactSuccess = createAction('[Lists-Contact] Fetch contact success', props<{ contact: ListFullContact }>());
export const FetchContactError = createAction('[Lists-Contact] Fetch contact error', props<{ error: any }>());
export const CheckMultipleRecords = createAction('[Lists-Contact] Check/Uncheck records', props<{ ids: Array<string>, isChecked: boolean }>());
export const SelectContact = createAction('[List-Contact] Select Contact', props<{ id: string }>());
export const ClearAllSelectedContacts = createAction('[List-Contact] Clear All Selected Contacts');
export const UpdatePage = createAction('[List-Contact] Update page', props<{ page: number }>());
export const ContactSearchParam = createAction('[List-Contact] Search filters', props<{ search: string }>());
export const UpdateExportInProgress = createAction('[List-Contact] Export Progress', props<{ inProgress: boolean }>());
